import { BaseService } from "services/_baseService";
import appAxios from "services/axios";
import { toQueryParams } from "helpers/url";
import { AIFunctionUpdateDTO } from "interfaces/DTO/AIFunctionsDTO";
import { AIFunctionCreateDTO } from "interfaces/DTO/AIFunctionsDTO";
class AgentsAdminService extends BaseService<any> {
  constructor() {
    super(`ai-agents`);
  }

  /**
   * Получение функций агента
   * @param agentID 
   * @param queryParams 
   * @returns 
   */
  getAIFunctions = (agentID: number, queryParams: any = {}) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/${agentID}/functions?` + toQueryParams(queryParams));
  }

  /**
   * Создание функции агента
   * @param agentID 
   * @param data 
   * @returns 
   */
  createAIFunction = (agentID: number, data: AIFunctionCreateDTO) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.post(`/admin/orgs/${orgID}/ai-agents/${agentID}/functions`, data);
  }

  /**
   * Получение функции агента
   * @param agentID 
   * @param functionID 
   * @returns 
   */
  getAIFunction = (agentID: number, functionID: number) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/${agentID}/functions/${functionID}`);
  }

  /**
   * Обновление функции агента
   * @param agentID 
   * @param functionID 
   * @param data 
   * @returns 
   */
  updateAIFunction = (agentID: number, functionID: number, data: AIFunctionUpdateDTO) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.put(`/admin/orgs/${orgID}/ai-agents/${agentID}/functions/${functionID}`, data);
  }

  /**
   * Удаление функции агента
   * @param agentID 
   * @param functionID 
   * @returns 
   */
  deleteAIFunction = (agentID: number, functionID: number) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.delete(`/admin/orgs/${orgID}/ai-agents/${agentID}/functions/${functionID}`);
  }

  /**
   * Получение токена Instagram
   * @param code 
   * @returns 
   */
  getInstagramToken = (channelConnectionID: number, code: string, state: any) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.post(`/admin/orgs/${orgID}/channel-connections/${channelConnectionID}/connect-instagram`, { code, state });
  }

  /**
   * Отсоединение от Instagram
   * @param channelConnectionID 
   * @returns 
   */
  disconnectInstagram = (channelConnectionID: number) => {
    const orgID = localStorage.getItem("orgID");
    return appAxios.post(`/admin/orgs/${orgID}/channel-connections/${channelConnectionID}/disconnect-instagram`);
  }
  // Количество диалогов по агенту за месяц
  getDialogCounts = (queryParams: any = {}) => {
    const orgID = localStorage.getItem("orgID");
    const qp = toQueryParams(queryParams)

    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/stats/dialogs-count?${qp}`);
  }

  getLeadCounts = (queryParams: any = {}) => {
    const orgID = localStorage.getItem("orgID");
    const qp = toQueryParams(queryParams)
    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/stats/leads-count?${qp}`);
  }
  getLeadConversionRate = (queryParams: any = {}) => {
    const orgID = localStorage.getItem("orgID");
    const qp = toQueryParams(queryParams)
    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/stats/leads-conversion-rate?${qp}`);
  }
  getAverageTime = (queryParams: any = {}) => {
    const orgID = localStorage.getItem("orgID");
    const qp = toQueryParams(queryParams)
    return appAxios.get(`/admin/orgs/${orgID}/ai-agents/stats/average-time?${qp}`);
  }
}

export default new AgentsAdminService();
